import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios'
import { storeToRefs } from 'pinia'

import useAuthStore from '@/stores/auth'
import { Headers } from '@/utilities/constants'
import env from '@/config/env'

type AdditionalOptions = Partial<{
  withBasicAuth: boolean
  isVaix: boolean
}>

function createAxiosInstance(
  options: AxiosRequestConfig,
  additionalHeaders?: Headers[],
  additionalOptions?: AdditionalOptions
): AxiosInstance {
  const instance = axios.create(options)

  instance.interceptors.request.use((config) => {
    const authStore = useAuthStore()

    const { authData } = storeToRefs(authStore)

    const headersMapper: Record<Headers, string> = {
      [Headers.CompanyUUID]: env.tenant.uuid,
      [Headers.TenantUUID]: env.tenant.uuid,
      [Headers.Authorization]: `Bearer ${additionalOptions?.isVaix ? env.vaix.token : authData.value?.jwt}`,
      [Headers.RequestID]: crypto.randomUUID(),
      [Headers.VaixClientID]: env.vaix.clientId
    }

    config.headers[Headers.RequestID] = headersMapper[Headers.RequestID]

    additionalHeaders?.forEach((header) => {
      config.headers[header] = headersMapper[header]
    })

    if (additionalOptions?.withBasicAuth) {
      config.auth = env.basicAuth
    }

    return config
  })

  return instance
}

export { createAxiosInstance }
